import request from '../utils/csrf-superagent';
import config from '../config';
import actions from '../actions/actions';
import payoutDetailsActions from '../actions/payoutDetails';

async function getPayoutMetadata(store) {
    try {
        const response = await request.get(`/${config.url_prefix}/api/getPayoutMetadata?site=${store.getState().system.siteName}`);
        const res = JSON.parse(response.text);
        store.dispatch(payoutDetailsActions.getPayoutMetadataSuccess(res));
    } catch (error) {
        if (error.response) {
            store.dispatch(payoutDetailsActions.alertError('ipmob.internal.server.error'));
        } else {
            store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
        }
    } finally {
        store.dispatch(actions.enableLoadOverLay(false));
    }
}

export default getPayoutMetadata;
